<template>
  <div>
    <div class="main_main">
      <div class="main">
        <div class="title">
          <!--        <img src="../../assets/index/title.png" class="title_img"></img>-->
          <img src="../../assets/index/title.png" class="title_img">
        </div>
        <div class="user_div">
          <div class="user">
            欢迎你：<span>{{ userName }}</span> | <a @click="logout">退出</a>
          </div>
        </div>
        <div class="main_border">
          <!-- <div class="title_bottom">
            <img src="../../assets/index/title_bottom.png" class="title_bottom_img">
          </div> -->
          <div class="center_center">
            <div>
              <div class="img_center">
                <div @click="toZhgl">
                  <img src="../../assets/index/zonghe.png" class="zonghe_img">
                </div>
                <div class="doushi_img" @click="toGldb">多式联运平台</div>
                <div class="yitishi_img" @click="toCxpt">一体化出行平台</div>
              </div>
              <div class="img_bottom">
                <!-- <div class="img_bottom_left"> -->
                <!-- <div>
                  <img src="../../assets/index/zhihui1.png" class="img_bottom_left_img">
                </div> -->
                <div class="zhihui_img" @click="toZHPT">指挥调度平台</div>
                <!-- </div> -->
                <!-- <div class="img_bottom_right" @click="toHjzx"> -->
                <!-- <div><img src="../../assets/index/cang.png" class="img_bottom_right_img"></div> -->
                <div class="cang_img" @click="toHjzx">智慧客服</div>

                <!-- </div> -->
                <!-- <div class="img_bottom_right" @click="toHjzx"> -->
                <!-- <div><img src="../../assets/index/dui.png" class="img_bottom_right_img"></div> -->
                <div class="dui_img" @click="toDcglxt">智慧场站</div>
                <!-- </div> -->

                <div class="yun_img" @click="toYuncang">5G云仓</div>

              </div>
            </div>
          </div>
          <!-- 多式联运-->
          <div class="bottom">
            <!--<img src="../../assets/index/bottom.png" class="bottom_img">-->
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import cas from "@/libs/util-cas";
import Setting from "@/setting";
//指挥调度平台
const zhdd_url = "https://testscreen.lywly.com.cn/"
//5G 云仓
const yunc_url = "https://lywms.lywly.com.cn/loginFromCas"
//综合管理平台
const zhgl_url = "https://manage.lywly.com.cn/home";
//公路短驳系统地址
const gldb_url = "https://admin.lywly.com.cn:19000/";
//一体化出行平台
// const cxpt_url = "http://140.249.220.131:19121/"
const cxpt_url = "http://182.37.141.193:19121/"
//呼叫中心
const hjzx_url = "http://182.37.34.38:9001/"
//堆场管理系统
const dcglxt_url = "https://zbtlwl.lywly.com.cn/web/plat/#/home"
export default {
  name: 'index',
  computed: {
    userName() {
      if (this.$store.state.user.userInfo !== null) {
        return `${this.$store.state.user.userInfo.familyName}${this.$store.state.user.userInfo.name}`
      } else {
        return ''
      }
    }
  },
  methods: {
    init() {
      this.getUserInfo()
    },
    getUserInfo() {
      this.$http.get('/api/system/cscpCurrentUserDetails').then(response => {
        this.$store.commit('user/setUserInfo', response.data)
      }).catch()
    },
    //指挥调度平台
    toZHPT() {
      window.open(zhdd_url, '_blank')
    },
    //5G云仓
    toYuncang() {
      window.open(yunc_url, '_blank')
    },
    //跳转综合管理平台
    toZhgl() {
      // this.$router.push({path: '/home'})
      window.open(zhgl_url, '_blank')
    },
    //跳转公路短驳
    toGldb() {
      window.open(gldb_url, '_blank')
      // window.location.href=gldb_url;
    },
    //跳转一体化出行平台
    toCxpt() {
      window.open(cxpt_url, '_blank')
      // window.location.href=cxpt_url;
    },
    //跳转呼叫中心
    toHjzx() {
      window.open(hjzx_url, '_blank')
    },
    //跳转堆场管理系统
    toDcglxt() {
      window.open(dcglxt_url, '_blank')
    },
    //退出
    logout() {
      this.$store.commit('user/logout')
      //TODO CAS调整 登录
      if (Setting.isCas) {
        cas.logout()
      } else {
        this.$router.push('/login')
      }
    }
  },
  created() {
    this.init()
  }

}
</script>

<style scoped>
.body {
  margin: 0 !important;
}

.main_main {
  /*display: flex;*/
  /*align-items: center;*/
  /*border: red 5px solid;*/
  /*width: 100%;*/
  /*height: 100%;*/

}

.main {
  background-image: url("../../assets/index/beijing.png");
  /* overflow-y: auto; */
  /*overflow-x:scroll;*/
  width: 100%;
  height: 100%;
  /*height: 683px;*/
  background-size: 100% 100%;
  position: fixed;
  text-align: center;
  /*border: black 10px solid;*/
  padding: 10px 10px;
}

.user_div {
  display: flex;
  justify-content: center;

}

.user {
  width: 1471px;
  /*border: black 1px solid;*/
  color: #D0E4FF;
  font-size: 21px;
  display: flex;
  justify-content: right;
  /*text-align: center;*/
  margin-right: 58px;
}

.title {
  /*margin-top: 0.87%;*/
}

.title_img {
  width: 593px;
  height: 77px;
}

.title_bottom_img {
  width: 428px;
  height: 10px;
}

.main_border {
  background-image: url("../../assets/index/zhouwei.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  /*width: 1471px;*/
  height: 90%;
  margin: 0px auto;
}

.img_center {
  display: flex;
  justify-content: center;
  /*border: black 5px solid;*/
}

.zonghe_img {
  width: 430px;
  height: 340px;
  /*margin-top: 115px;*/
  margin-right: 10px;
}

.doushi_img {
  background-image: url("../../assets/index/duoshi.png");
  background-repeat: no-repeat;
  width: 430px;
  height: 340px;
  /*height: 312px;106px*/
  margin: 0px 10px 0px 10px;
  background-size: 100% 100%;
  padding-top: 220px;
  font-size: 29px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
}

.zhihui_img {
  background-image: url("../../assets/index/zhihui1.png");
  background-repeat: no-repeat;
  width: 320px;
  height: 183px;
  margin: 0px 10px 0px 0px;
  background-size: 100% 100%;
  padding-top: 106px;
  font-size: 29px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
}

.cang_img {
  background-image: url("../../assets/index/cang.png");
  background-repeat: no-repeat;
  width: 320px;
  height: 183px;
  margin: 0px 10px 0px 10px;
  background-size: 100% 100%;
  padding-top: 106px;
  font-size: 29px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
}

.dui_img {
  background-image: url("../../assets/index/dui.png");
  background-repeat: no-repeat;
  width: 320px;
  height: 183px;
  margin: 0px 0px 0px 10px;
  background-size: 100% 100%;
  padding-top: 106px;
  font-size: 29px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
}

.yun_img {
  background-image: url("../../assets/index/5G.png");
  background-repeat: no-repeat;
  width: 320px;
  height: 183px;
  margin: 0px 0px 0px 10px;
  background-size: 100% 100%;
  padding-top: 106px;
  font-size: 29px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
}

.yitishi_img {
  width: 430px;
  height: 340px;
  background-image: url("../../assets/index/yitihua.png");
  background-repeat: no-repeat;
  /*123px*/
  margin: 0px 0px 0px 10px;
  background-size: 100% 100%;
  padding-top: 220px;
  font-size: 29px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
}

.img_bottom {
  display: flex;
  justify-content: center;
  margin-top: 16px;
  /*border: black 5px solid;*/
}

.img_bottom_left {
  /* background: url("../../assets/index/zhihuiB.png") center center no-repeat;
  width: 503px;
  height: 157px;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center; */
}

.img_bottom_right {
  /* background: url("../../assets/index/cangkuB.png") center center no-repeat; */
  width: 503px;
  height: 157px;
  background-size: 100% 100%;
  margin-left: 28px;
  /* display: flex; */
  /* justify-content: center; */
  /* align-items: center */
}

.img_bottom_left_text {
  margin-left: 26px;
  font-size: 29px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 27px;
}

.bottom {
  /*margin-top: 125px;*/
}

.center_center {
  height: 93%;
  display: flex;
  justify-content: center;
  align-items: center
}
</style>
